export type UPDATE_COVID19_REQUEST_FLAG = 'UPDATE_COVID19_REQUEST_FLAG';
export const UPDATE_COVID19_REQUEST_FLAG: UPDATE_COVID19_REQUEST_FLAG = 'UPDATE_COVID19_REQUEST_FLAG';

export type UPDATE_COVID19_INCIDENT_FLAG = 'UPDATE_COVID19_INCIDENT_FLAG';
export const UPDATE_COVID19_INCIDENT_FLAG: UPDATE_COVID19_INCIDENT_FLAG = 'UPDATE_COVID19_INCIDENT_FLAG';

export type CHANNEL_CARE_LOAD_CASES = 'CHANNEL_CARE/LOAD_CASES';
export const CHANNEL_CARE_LOAD_CASES: CHANNEL_CARE_LOAD_CASES = 'CHANNEL_CARE/LOAD_CASES';

export type CHANNEL_CARE_LOAD_CASES_INT = 'CHANNEL_CARE/LOAD_CASES_INT';
export const CHANNEL_CARE_LOAD_CASES_INT: CHANNEL_CARE_LOAD_CASES_INT = 'CHANNEL_CARE/LOAD_CASES_INT';

export type CHANNEL_CARE_LOAD_SUMMARY = 'CHANNEL_CARE/LOAD_SUMMARY';
export const CHANNEL_CARE_LOAD_SUMMARY: CHANNEL_CARE_LOAD_SUMMARY = 'CHANNEL_CARE/LOAD_SUMMARY';

export type CHANNEL_CARE_LOAD_SUMMARY_CASES = 'CHANNEL_CARE/LOAD_SUMMARY_CASES';
export const CHANNEL_CARE_LOAD_SUMMARY_CASES: CHANNEL_CARE_LOAD_SUMMARY_CASES = 'CHANNEL_CARE/LOAD_SUMMARY_CASES';

export type CHANNEL_CARE_SUMBIT_ENQUIRY = 'CHANNEL_CARE/SUBMIT_ENQUIRY';
export const CHANNEL_CARE_SUMBIT_ENQUIRY: CHANNEL_CARE_SUMBIT_ENQUIRY = 'CHANNEL_CARE/SUBMIT_ENQUIRY';

export type CHANNEL_CARE_LOAD_CASE_DETAILS = 'CHANNEL_CARE/LOAD_CASE_DETAILS';
export const CHANNEL_CARE_LOAD_CASE_DETAILS: CHANNEL_CARE_LOAD_CASE_DETAILS = 'CHANNEL_CARE/LOAD_CASE_DETAILS';

export type CHANNEL_CARE_LOAD_CASE_ACTIVITY = 'CHANNEL_CARE/LOAD_CASE_ACTIVITY';
export const CHANNEL_CARE_LOAD_CASE_ACTIVITY: CHANNEL_CARE_LOAD_CASE_ACTIVITY = 'CHANNEL_CARE/LOAD_CASE_ACTIVITY';

export type CHANNEL_CARE_ADD_COMMENT = 'CHANNEL_CARE/ADD_COMMENT';
export const CHANNEL_CARE_ADD_COMMENT: CHANNEL_CARE_ADD_COMMENT = 'CHANNEL_CARE/ADD_COMMENT';

export type CHANNEL_CARE_LOAD_ACCOUNT_NUMBERS = 'CHANNEL_CARE/LOAD_ACCOUNT_NUMBERS';
export const CHANNEL_CARE_LOAD_ACCOUNT_NUMBERS: CHANNEL_CARE_LOAD_ACCOUNT_NUMBERS = 'CHANNEL_CARE/LOAD_ACCOUNT_NUMBERS';

export type TICKET_FILE_UPLOAD = 'CHANNEL_CARE/TICKET_FILE_UPLOAD';
export const TICKET_FILE_UPLOAD: TICKET_FILE_UPLOAD = 'CHANNEL_CARE/TICKET_FILE_UPLOAD';

export type CHANNEL_CARE_LOAD_COMPANY_IDS = 'CHANNEL_CARE/LOAD_COMPANY_IDS';
export const CHANNEL_CARE_LOAD_COMPANY_IDS: CHANNEL_CARE_LOAD_COMPANY_IDS = 'CHANNEL_CARE/LOAD_COMPANY_IDS';

export type CHANNEL_CARE_LOAD_ORDER_REF = 'CHANNEL_CARE/LOAD_ORDER_REF';
export const CHANNEL_CARE_LOAD_ORDER_REF: CHANNEL_CARE_LOAD_ORDER_REF = 'CHANNEL_CARE/LOAD_ORDER_REF';

export type BILLING_LOAD_ADJUSTMENT_LIST = 'BILLING/LOAD_ADJUSTMENT_LIST';
export const BILLING_LOAD_ADJUSTMENT_LIST: BILLING_LOAD_ADJUSTMENT_LIST = 'BILLING/LOAD_ADJUSTMENT_LIST';

export type BILLING_LOAD_INVOICES_LIST = 'BILLING/LOAD_INVOICES_LIST';
export const BILLING_LOAD_INVOICES_LIST: BILLING_LOAD_INVOICES_LIST = 'BILLING/LOAD_INVOICES_LIST';

export type CHANNEL_CARE_LOAD_FORM_CONFIG = 'CHANNEL_CARE/LOAD_FORM_CONFIG';
export const CHANNEL_CARE_LOAD_FORM_CONFIG: CHANNEL_CARE_LOAD_FORM_CONFIG = 'CHANNEL_CARE/LOAD_FORM_CONFIG';

export type CHANNEL_CARE_SUBMIT_FORM_DATA = 'CHANNEL_CARE/SUBMIT_FORM_DATA';
export const CHANNEL_CARE_SUBMIT_FORM_DATA: CHANNEL_CARE_SUBMIT_FORM_DATA = 'CHANNEL_CARE/SUBMIT_FORM_DATA';

export type CHANNEL_CARE_LOAD_CUSTOMER_CONTACT_DATA = 'CHANNEL_CARE/LOAD_CUSTOMER_CONTACT_DATA';
export const CHANNEL_CARE_LOAD_CUSTOMER_CONTACT_DATA:
CHANNEL_CARE_LOAD_CUSTOMER_CONTACT_DATA = 'CHANNEL_CARE/LOAD_CUSTOMER_CONTACT_DATA';

export type CHANNEL_CARE_LOAD_ATTACHMENTS = 'CHANNEL_CARE/LOAD_ATTACHMENTS';
export const CHANNEL_CARE_LOAD_ATTACHMENTS:
CHANNEL_CARE_LOAD_ATTACHMENTS = 'CHANNEL_CARE/LOAD_ATTACHMENTS';

export type CHANNEL_CARE_UPDATE_SORTING = 'CHANNEL_CARE/UPDATE_SORTING';
export const CHANNEL_CARE_UPDATE_SORTING: CHANNEL_CARE_UPDATE_SORTING = 'CHANNEL_CARE/UPDATE_SORTING';

export type CHANNEL_CARE_LIST_FILTER = 'CHANNEL_CARE_LIST_FILTER';
export const CHANNEL_CARE_LIST_FILTER: CHANNEL_CARE_LIST_FILTER = 'CHANNEL_CARE_LIST_FILTER';

export type CHANNEL_CARE_STORE_FILTER = 'CHANNEL_CARE_STORE_FILTER';
export const CHANNEL_CARE_STORE_FILTER: CHANNEL_CARE_STORE_FILTER = 'CHANNEL_CARE_STORE_FILTER';

export type CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN = 'CHANNEL_CARE/LOAD_COMPANY_MULTI_CIDN';
export const CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN:
CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN = 'CHANNEL_CARE/LOAD_COMPANY_MULTI_CIDN';

export type CHANNEL_CARE_UPDATE_COMPANY_ID = 'CHANNEL_CARE/UPDATE_COMPANY_ID';
export const CHANNEL_CARE_UPDATE_COMPANY_ID:
CHANNEL_CARE_UPDATE_COMPANY_ID = 'CHANNEL_CARE/UPDATE_COMPANY_ID';

export type CHANNEL_CARE_LOAD_COMPANIES = 'CHANNEL_CARE/LOAD_COMPANIES';
export const CHANNEL_CARE_LOAD_COMPANIES:
CHANNEL_CARE_LOAD_COMPANIES = 'CHANNEL_CARE/LOAD_COMPANIES';

export type UPDATE_PROMO_BANNER_FLAG = 'UPDATE_PROMO_BANNER_FLAG';
export const UPDATE_PROMO_BANNER_FLAG: UPDATE_PROMO_BANNER_FLAG = 'UPDATE_PROMO_BANNER_FLAG';
